<script>
	// Imports
	import { GoogleAuthProvider, onAuthStateChanged } from "firebase/auth";
	import {
		doc,
		collection,
		addDoc,
		setDoc,
		getDoc,
		updateDoc,
		arrayUnion,
		onSnapshot,
		deleteField,
		serverTimestamp,
		increment,
	} from "firebase/firestore";
	import { logEvent } from "firebase/analytics";
	import { uiText } from "../lib/uiText.js";
	import Messageboard from "./Messageboard.svelte";
	import { createEventDispatcher } from "svelte";
	import GameFooter from "./GameFooter.svelte";
	import GameHeader from "./GameHeader.svelte";
	import Hints from "./Hints.svelte";
	import InputSimple from "./InputSimple.svelte";
	import InputComplex from "./InputComplex.svelte";
	import BonusHeader from "./BonusHeader.svelte";
	import { gamerule } from "../lib/gameRules.js";
	import { map } from "../lib/map.js";
	import InputReorder from "./InputReorder.svelte";
	import InputButtoned from "./InputButtoned.svelte";
	import InputQr from "./InputQR.svelte";
	import Mapbox from "./Mapbox.svelte";
	import GeoRiddle from "./GeoRiddle.svelte";
	import TutorialOverlay from "./TutorialOverlay.svelte";
	// import Tutorial from "./Tutorial.svelte";
	import SkippableHeader from "./SkippableHeader.svelte";
	import PlayerChat from "./PlayerChat.svelte";
	import SessionTimer from "./SessionTimer.svelte";
	const dispatch = createEventDispatcher();

	// Firebase
	export let auth;
	export let db;
	export let storage;
	export let analytics;

	// Global
	export const v = "?rev=06171920";
	//  Update v = version globally
	export let lang;
	let state;
	let tutorial_state = false;
	export let user;
	export let loader;
	let microinput = true;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader);

	// Local
	let msg_type = "info";
	let msg_content = "";
	let msg_shown = false;
	let msg_action = "Okay";
	let msg_color = false;
	let surrender = false;
	let surrender_input = "";
	let hasMap = false; //false
	let mapOpen = false; //false
	let hasChat = false; //false
	let chatOpen = false; //false

	let autoGeolocate = false; // false

	let sessionData = {};
	let gameData = {};

	let mapData = {};

	$: gameData, gameData;

	onAuthStateChanged(auth, (authUser) => {
		if (authUser) {
			// list of available properties - https://firebase.google.com/docs/reference/js/firebase.User
			user.name = authUser.displayName;
			user.photo = authUser.photoURL;
			user.uid = authUser.uid;
			checkActiveSession(authUser.uid);
		} else {
			loader = true;
			dispatch("state", "login");
			// console.warn('USER IS OUT, I REPEAT, USER IS OUT!');
		}
	});

	async function checkActiveSession(authUID) {
		const actSesSnap = await getDoc(doc(db, "users", authUID));

		if (actSesSnap.exists()) {
			let snapData = actSesSnap.data();
			if (snapData.hasActiveSession) {
				startListener(snapData.activeSessionID);
			}
		} else {
			console.log("No such document!");
		}
	}

	function startListener(listener) {
		const listenTo = listener || user.activeSessionID;
		const listening = onSnapshot(doc(db, "sessions", listenTo), (doc) => {
			const source = doc.metadata.hasPendingWrites ? "Local" : "Server";
			// console.log(source, ' data: ', doc.data());

			/** temp experimentations
let onlineSessionData = doc.data();
			// sessionData = doc.data(); //temp removal
			// console.log(sessionData);
			// sessionData.access_code = sessionData.access_code;
			// console.log(sessionData);
			if (
				onlineSessionData.current_task == sessionData.current_task &&
				onlineSessionData.answers == sessionData.answers &&
				onlineSessionData.hints == sessionData.hints
			) {
				console.log("minor change, no need for update");
				//and no hint change
				// console.log('no task difference, do not add loader');
				// loader = true;
			} else {
				console.log("deemed as major change, must update");
				sessionData = onlineSessionData;
				// console.log('is task difference, do add loader');
				loader = true;
				microinput = false;
			} 
* */

			let current_task = sessionData.current_task;
			sessionData = doc.data();
			// console.log(sessionData);
			// sessionData.access_code = sessionData.access_code;
			// console.log(sessionData);
			if (sessionData.current_task == current_task) {
				//and no hint change
				// console.log('no task difference, do not add loader');
				// loader = true;
			} else {
				// console.log('is task difference, do add loader');
				loader = true;
			}
			microinput = false;

			getCurrentTask();
		});
		// console.warn("Listener started!");
	}

	async function getCurrentTask() {
		if (
			sessionData.current_task == "conclusion" &&
			sessionData.current_task == "zteakujehucihiafaha"
		) {
			// localStorage.setItem('showConclusion', true);
			state = "conclusion";
			dispatch("state", state);
		} else {
			microinput = false;
			const taskRef = doc(
				db,
				"games",
				sessionData.game.gid,
				"gamedata",
				sessionData.current_task,
			);
			// console.log('games', sessionData.game.gid, 'gamedata', sessionData.current_task);
			const taskRefSnap = await getDoc(taskRef);
			if (taskRefSnap.exists()) {
				// let onlineTaskData = taskRefSnap.data();
				// console.log(gameData);
				// console.warn(onlineTaskData);
				// if (gameData.taskData == undefined || gameData.taskData == false) {
				// console.error("taskData undefined line -  load data");

				// gameData.taskData = taskRefSnap.data();
				// } else {
				//COMPARE SESSION DATA, NOT GAME DATA
				// console.log(
				// 	"gdct - ",
				// 	gameData.taskData.current_task,
				// 	"onlinect - ",
				// 	sessionData.current_task
				// );
				// if (
				// 	gameData.taskData.current_task == onlineTaskData.current_task &&
				// 	gameData.taskData.hints == onlineTaskData.hints &&
				// 	gameData.taskData.answers == onlineTaskData.answers
				// ) {
				// 	console.log("no major change, no need to update");
				// } else {
				// 	microinput = false;
				gameData.taskData = {};
				// attempt to solve geo issue
				gameData.taskData = taskRefSnap.data();

				hasMap = false;
				mapData = "";
				if (gameData.taskData.map_content) {
					hasMap = true;
					mapData = gameData.taskData.map_content;
				} else {
					hasMap = false;
				}

				if (
					(gameData.taskData.hasChat && !sessionData.chatEnabled) ||
					sessionData.chatEnabled
				) {
					hasChat = true;
				} else {
					hasChat = false;
				}

				// 		console.log("MAJOR CHANGE - UPDATE - UPDATE - UPDATE");
				// 	}
				// }

				/// UPDATE HERE to update only if major change happens.

				// console.log(gameData.taskData);

				loader = false;
				microinput = true;
				checkCustomScripting();

				//To Do: Check if TUTORIAL should be shown.
				if (gameData.taskData.showTutorial) {
					// console.log("show tutorial", gameData.taskData.showTutorial);
					tutorial_state = gameData.taskData.showTutorial;
				}
				//SHOW tutorial if needed.
				//turn OFF tutorial by default.

				// console.warn(taskRefSnap.data());
			} else {
				console.log(
					"No such task to be found! Contact admin, that's a big issue!",
				);
				handleMessage({
					detail: {
						msg_type: "error",
						msg_content: ui.game.riddle.could_not_locate,
					},
				});
			}
		}
	}

	function checkTooFast() {
		if (
			((
				sessionData?.session?.riddleTimes
					? Object.keys(sessionData?.session?.riddleTimes).length > 0
					: false
			)
				? Math.max(
						...Object.values(sessionData.session.riddleTimes).map(
							(item) => item.seconds,
						),
					) + 30
				: sessionData?.session?.sessionStart.seconds) +
				30 >=
			Math.floor(Date.now() / 1000)
		) {
			// Answer too fast!
			handleMessage({
				detail: {
					msg_type: "info",
					msg_content: ui.game.riddle.not_too_fast,
				},
			});
			// console.log(
			// 	Math.max(
			// 		...Object.values(sessionData.session.riddleTimes).map(
			// 			(item) => item.seconds
			// 		)
			// 	) + 30,
			// 	Math.floor(Date.now() / 1000),
			// 	((
			// 		sessionData?.session?.riddleTimes
			// 			? Object.keys(sessionData?.session?.riddleTimes).length > 0
			// 			: false
			// 	)
			// 		? Math.max(
			// 				...Object.values(sessionData.session.riddleTimes).map(
			// 					(item) => item.seconds
			// 				)
			// 			) + 30
			// 		: sessionData?.session?.sessionStart.seconds) +
			// 		30 >=
			// 		Math.floor(Date.now() / 1000)
			// );
			console.log("Too fast...");
			return true;
		} else {
			// console.log("Not too fast...");
			return false;
		}
	}

	async function leaveSession() {
		const userRef = doc(db, "users", user.uid);
		const sessionRef = doc(db, "sessions", sessionData.session.sid);
		// deleteField()
		await updateDoc(
			userRef,
			{
				activeSessionID: deleteField(),
				hasActiveSession: false,
			},
			{ merge: true },
		);
		await updateDoc(
			sessionRef,
			{
				["session.players." + user.uid]: deleteField(),
			},
			{ merge: true },
		).then(() => {
			// state = 'user';
			loader = true;
			logEvent(analytics, "session_ingame_player_left");
			dispatch("state", "login");
		});
	}

	function handleInput(e) {
		// console.log(e.detail);
	}
	async function handleUsingHint(e) {
		let data = e.detail;
		const sessionRef = doc(db, "sessions", sessionData.session.sid);
		await updateDoc(
			sessionRef,
			{
				["hints.hintsUsed." +
				sessionData.current_task +
				"." +
				Object.keys(data)[0]]: Object.values(data)[0],
			},
			{ merge: true },
		);

		// console.log(sessionData.hints.hintsUsed[sessionData.current_task]);
		// console.log(e.detail);
	}

	function handleMessage(e) {
		// console.log('message:' + e.detail);
		if (e.detail.hasOwnProperty("msg_type")) {
			msg_type = e.detail.msg_type;
		} else {
			msg_type = "default";
		}

		msg_content = e.detail.msg_content;

		if (e.detail.hasOwnProperty("msg_action")) {
			msg_action = e.detail.msg_action;
		} else {
			msg_action = ui.game.riddle.default_action;
		}

		if (e.detail.hasOwnProperty("msg_color")) {
			msg_color = e.detail.msg_color;
		} else {
			msg_color = false;
		}
		msg_shown = true;
		// console.log(msg_shown);
	}

	async function handleWrongAnswer(e) {
		// console.warn("wrong answer handling begin");
		const sessionRef = doc(db, "sessions", sessionData.session.sid);
		await updateDoc(
			sessionRef,
			{
				["wrongAnswers." + sessionData.current_task + "." + user.uid]:
					arrayUnion(e.detail.wrongAnswer), //singular wrong answer to be added
				// ^ this could become redundant
				// ["session.normal_riddles_solved"]: increment(normalIncrement),
				// ["session.bonus_riddles_solved"]: increment(bonusIncrement),
				// current_task: e.detail.address,
			},
			{ merge: true },
		).then(() => {
			getCurrentTask();
			// loader = false;
			// console.warn("wrong answer handling over");
		});
	}

	async function handleSolve(e) {
		if (checkTooFast()) {
			return true;
		} else {
			if (e.detail.address === gameData.taskData.rd_content.address) {
				const sessionRef = doc(db, "sessions", sessionData.session.sid);
				let normalIncrement, bonusIncrement;

				if (
					e.detail.address !== "zteakujehucihiafaha" &&
					e.detail.address !== "conclusion"
				) {
					loader = true;
					let incrementalDirectory = "session.normal_riddles_solved_ids";
					if (e.detail.isBonus) {
						normalIncrement = 0;
						bonusIncrement = 1;
						incrementalDirectory = "session.bonus_riddles_solved_ids";
					} else {
						normalIncrement = 1;
						bonusIncrement = 0;
						incrementalDirectory = "session.normal_riddles_solved_ids";
					}
					await updateDoc(
						sessionRef,
						{
							// ["wrongAnswers." + sessionData.current_task + "." + user.uid]:
							// 	e.detail.wrongAnswers,
							// ^ this could become redundant
							["session.normal_riddles_solved"]: increment(normalIncrement),
							["session.bonus_riddles_solved"]: increment(bonusIncrement),
							[incrementalDirectory]: arrayUnion(sessionData.current_task),
							["session.riddleTimes." + sessionData.current_task]:
								serverTimestamp(),
							current_task: e.detail.address,
						},
						{ merge: true },
					).then(() => {
						getCurrentTask();
						// loader = false;
					});
					// addToLeaderboard();
				} else {
					let incrementalDirectory = "session.normal_riddles_solved_ids";
					if (e.detail.isBonus) {
						normalIncrement = 0;
						bonusIncrement = 1;
						incrementalDirectory = "session.bonus_riddles_solved_ids";
					} else {
						normalIncrement = 1;
						bonusIncrement = 0;
						incrementalDirectory = "session.normal_riddles_solved_ids";
					}
					await updateDoc(
						sessionRef,
						{
							["wrongAnswers." + sessionData.current_task + "." + user.uid]:
								e.detail.wrongAnswers,
							"session.normal_riddles_solved": increment(normalIncrement),
							"session.bonus_riddles_solved": increment(bonusIncrement),
							[incrementalDirectory]: arrayUnion(sessionData.current_task),
							"session.ended": true,
							"session.sessionEnd": serverTimestamp(),
							["session.riddleTimes." + sessionData.current_task]:
								serverTimestamp(),
							current_task: "conclusion",
						},
						{ merge: true },
						// ).then(() => addToLeaderboard());
					); // either this or the one above
					loader = true;
					// add to access code data

					const accCodeRef = doc(
						db,
						"game-activation-codes",
						sessionData.session.activation_code,
					);
					await updateDoc(
						//this should happen to all users that are in the session
						accCodeRef,
						{
							game_over: true,
						},
						{ merge: true },
					);

					// console.log(sessionData.session.players);
					let playersArray = Object.keys(sessionData.session.players);
					playersArray.forEach(async (element) => {
						const userRef = doc(db, "users", element);
						await updateDoc(
							//this should happen to all users that are in the session
							userRef,
							{
								activeSessionID: deleteField(),
								hasActiveSession: false,
								latestSession: sessionData.session.sid,
								showConclusion: true,
								pastSessions: arrayUnion(sessionData.session.sid),
							},
							{ merge: true },
						).then(() => {
							// console.log(element);
						});
					});
					location.reload();
					//reload when players reached conclusion
				}
			} else {
				// console.error("Don't try to cheat the system, please.");
			}
		}
	}

	async function handleComplexSolve() {
		if (checkTooFast()) {
			return true;
		} else {
			// console.log('handle complex solve');
			const sessionRef = doc(db, "sessions", sessionData.session.sid);
			let normalIncrement, bonusIncrement;

			if (
				gameData.taskData.rd_content.address !== "zteakujehucihiafaha" &&
				gameData.taskData.rd_content.address !== "conclusion"
			) {
				showMessage({
					msg_content: ui.game.riddle.single_message,
					msg_type: "info",
					msg_action: ui.game.riddle.single_action,
				});
				let incrementalDirectory = "session.normal_riddles_solved_ids";
				if (gameData.taskData.rd_content.isBonus) {
					normalIncrement = 0;
					bonusIncrement = 1;
					incrementalDirectory = "session.bonus_riddles_solved_ids";
				} else {
					normalIncrement = 1;
					bonusIncrement = 0;
					incrementalDirectory = "session.normal_riddles_solved_ids";
				}
				await updateDoc(
					sessionRef,
					{
						["session.normal_riddles_solved"]: increment(normalIncrement),
						["session.bonus_riddles_solved"]: increment(bonusIncrement),
						[incrementalDirectory]: arrayUnion(sessionData.current_task),
						["session.riddleTimes." + sessionData.current_task]:
							serverTimestamp(),
						current_task: gameData.taskData.rd_content.address,
					},
					{ merge: true },
				).then(() => {
					loader = true;
					getCurrentTask();
				});
			} else {
				let incrementalDirectory = "session.normal_riddles_solved_ids";
				if (gameData.taskData.rd_content.isBonus) {
					normalIncrement = 0;
					bonusIncrement = 1;
					incrementalDirectory = "session.bonus_riddles_solved_ids";
				} else {
					normalIncrement = 1;
					bonusIncrement = 0;
					incrementalDirectory = "session.normal_riddles_solved_ids";
				}
				await updateDoc(
					sessionRef,
					{
						current_task: "conclusion",
						["session.normal_riddles_solved"]: increment(normalIncrement),
						["session.bonus_riddles_solved"]: increment(bonusIncrement),
						[incrementalDirectory]: arrayUnion(sessionData.current_task),
						["session.riddleTimes." + sessionData.current_task]:
							serverTimestamp(),
						["session.ended"]: true,
						["session.sessionEnd"]: serverTimestamp(),
					},
					{ merge: true },
					// ).then(() => addToLeaderboard());
				); // either this or the one above
				// add to access code data

				const accCodeRef = doc(
					db,
					"game-activation-codes",
					sessionData.session.activation_code,
				);
				await updateDoc(
					accCodeRef,
					{
						game_over: true,
					},
					{ merge: true },
				);

				let playersArray = Object.keys(sessionData.session.players);
				playersArray.forEach(async (element) => {
					const userRef = doc(db, "users", element);
					await updateDoc(
						userRef,
						{
							activeSessionID: deleteField(),
							hasActiveSession: false,
							latestSession: sessionData.session.sid,
							showConclusion: true,
							pastSessions: arrayUnion(sessionData.session.sid),
						},
						{ merge: true },
					).then(() => {});
				});
			}
		}
	}
	// // MADE OBSOLETE BY GEMINI
	// async function handlePartialSolve(e) {
	// 	if (checkTooFast()) {
	// 		return true;
	// 	} else {
	// 		let data = e.detail;
	// 		const sessionRef = doc(db, "sessions", sessionData.session.sid);

	// 		await updateDoc(
	// 			sessionRef,
	// 			{
	// 				["answers.saidAnswers." +
	// 				sessionData.current_task +
	// 				"." +
	// 				Object.keys(data)[0]]: Object.values(data)[0],
	// 			},
	// 			{ merge: true },
	// 		);

	// 		if (
	// 			Object.keys(sessionData.answers.saidAnswers[sessionData.current_task])
	// 				.length ==
	// 			(gameData.taskData.rd_content.requiredAnswers ||
	// 				gameData.taskData.rd_content.answers.length)
	// 		) {
	// 			// console.log("they're equal");
	// 			showMessage({
	// 				msg_content: ui.game.riddle.multiple_all_message,
	// 				msg_type: "info",
	// 				msg_action: ui.game.riddle.multiple_all_action,
	// 			});
	// 			handleComplexSolve();
	// 		} else {
	// 			showMessage({
	// 				msg_content: ui.game.riddle.multiple_more_message,
	// 				msg_type: "info",
	// 				msg_action: ui.game.riddle.multiple_more_action,
	// 			});
	// 			// console.log('more to solve');
	// 		}

	// 		// console.log(sessionData.hints.hintsUsed[sessionData.current_task]);
	// 		// console.log(e.detail);
	// 	}
	// }
	// // MADE OBSOLETE BY GEMINI
	// async function handlePartialSolveType2(e) {
	// 	if (checkTooFast()) {
	// 		return true;
	// 	} else {
	// 		let data = e.detail;
	// 		// console.log(data);

	// 		let n = data.inActive.indexOf(true);
	// 		let saidAnswer;
	// 		// console.log(data.inActive.indexOf(true));
	// 		if (typeof gameData.taskData.rd_content.answers[n] === "object") {
	// 			saidAnswer = Object.values(gameData.taskData.rd_content.answers[n])[0];
	// 			// console.log(saidAnswer);
	// 		} else {
	// 			saidAnswer = gameData.taskData.rd_content.answers[n];
	// 			// console.log(saidAnswer);
	// 		}

	// 		const sessionRef = doc(db, "sessions", sessionData.session.sid);
	// 		await updateDoc(
	// 			sessionRef,
	// 			{
	// 				["answers.saidAnswers." +
	// 				sessionData.current_task +
	// 				"." +
	// 				saidAnswer]: true,
	// 			},
	// 			{ merge: true },
	// 		);

	// 		if (
	// 			Object.keys(sessionData.answers.saidAnswers[sessionData.current_task])
	// 				.length ==
	// 			(gameData.taskData.rd_content.requiredAnswers ||
	// 				gameData.taskData.rd_content.answers.length)
	// 		) {
	// 			// console.log("they're equal");
	// 			showMessage({
	// 				msg_content: ui.game.riddle.multiple_all_message,
	// 				msg_type: "info",
	// 				msg_action: ui.game.riddle.multiple_all_action,
	// 			});
	// 			handleComplexSolve();
	// 		} else {
	// 			// console.log('more to solve');
	// 			showMessage({
	// 				msg_content: ui.game.riddle.multiple_more_message,
	// 				msg_type: "info",
	// 				msg_action: ui.game.riddle.multiple_more_action,
	// 			});
	// 		}
	// 	}
	// 	// console.log(sessionData.hints.hintsUsed[sessionData.current_task]);
	// 	// console.log(e.detail);
	// }

	// ГЕМИНИ В 1.0
	// async function handlePartialSolve(e) {
	// 	if (checkTooFast()) {
	// 		return true;
	// 	} else {
	// 		let data = e.detail;
	// 		const sessionRef = doc(db, "sessions", sessionData.session.sid);

	// 		let updatePayload = {};

	// 		// 1. Ensure the local object exists to prevent undefined errors
	// 		if (!sessionData?.answers?.saidAnswers[sessionData.current_task]) {
	// 			sessionData.answers.saidAnswers[sessionData.current_task] = {};
	// 		}

	// 		// 2. Loop through all incoming answers
	// 		for (const [key, value] of Object.entries(data)) {
	// 			// Prepare Firebase update
	// 			updatePayload[
	// 				`answers.saidAnswers.${sessionData.current_task}.${key}`
	// 			] = value;
	// 			// Optimistically update local state immediately so length check works
	// 			sessionData.answers.saidAnswers[sessionData.current_task][key] = value;
	// 		}

	// 		// 3. Send a single batch update to Firebase
	// 		await updateDoc(sessionRef, updatePayload, { merge: true });

	// 		// 4. Check for victory (Using >= just in case they answered more than required!)
	// 		if (
	// 			Object.keys(sessionData.answers.saidAnswers[sessionData.current_task])
	// 				.length >=
	// 			(gameData.taskData.rd_content.requiredAnswers ||
	// 				gameData.taskData.rd_content.answers.length)
	// 		) {
	// 			showMessage({
	// 				msg_content: ui.game.riddle.multiple_all_message,
	// 				msg_type: "info",
	// 				msg_action: ui.game.riddle.multiple_all_action,
	// 			});
	// 			handleComplexSolve();
	// 		} else {
	// 			showMessage({
	// 				msg_content: ui.game.riddle.multiple_more_message,
	// 				msg_type: "info",
	// 				msg_action: ui.game.riddle.multiple_more_action,
	// 			});
	// 		}
	// 	}
	// }

	// async function handlePartialSolveType2(e) {
	// 	if (checkTooFast()) {
	// 		return true;
	// 	} else {
	// 		let data = e.detail;
	// 		const sessionRef = doc(db, "sessions", sessionData.session.sid);

	// 		let updatePayload = {};

	// 		if (!sessionData.answers.saidAnswers[sessionData.current_task]) {
	// 			sessionData.answers.saidAnswers[sessionData.current_task] = {};
	// 		}

	// 		// Loop through ALL items in the array, looking for EVERY true value
	// 		for (let i = 0; i < data.inActive.length; i++) {
	// 			if (data.inActive[i] === true) {
	// 				let saidAnswer;

	// 				// Find the matching string for this specific index
	// 				if (typeof gameData.taskData.rd_content.answers[i] === "object") {
	// 					saidAnswer = Object.values(
	// 						gameData.taskData.rd_content.answers[i],
	// 					)[0];
	// 				} else {
	// 					saidAnswer = gameData.taskData.rd_content.answers[i];
	// 				}

	// 				updatePayload[
	// 					`answers.saidAnswers.${sessionData.current_task}.${saidAnswer}`
	// 				] = true;
	// 				sessionData.answers.saidAnswers[sessionData.current_task][
	// 					saidAnswer
	// 				] = true;
	// 			}
	// 		}

	// 		await updateDoc(sessionRef, updatePayload, { merge: true });

	// 		if (
	// 			Object.keys(sessionData.answers.saidAnswers[sessionData.current_task])
	// 				.length >=
	// 			(gameData.taskData.rd_content.requiredAnswers ||
	// 				gameData.taskData.rd_content.answers.length)
	// 		) {
	// 			showMessage({
	// 				msg_content: ui.game.riddle.multiple_all_message,
	// 				msg_type: "info",
	// 				msg_action: ui.game.riddle.multiple_all_action,
	// 			});
	// 			handleComplexSolve();
	// 		} else {
	// 			showMessage({
	// 				msg_content: ui.game.riddle.multiple_more_message,
	// 				msg_type: "info",
	// 				msg_action: ui.game.riddle.multiple_more_action,
	// 			});
	// 		}
	// 	}
	// }

	async function handlePartialSolve(e) {
		if (checkTooFast()) {
			return true;
		} else {
			let data = e.detail;
			const sessionRef = doc(db, "sessions", sessionData.session.sid);

			let updatePayload = {};

			// 1. Defensively initialize the entire state tree
			if (!sessionData.answers) sessionData.answers = {};
			if (!sessionData.answers.saidAnswers)
				sessionData.answers.saidAnswers = {};
			if (!sessionData.answers.saidAnswers[sessionData.current_task]) {
				sessionData.answers.saidAnswers[sessionData.current_task] = {};
			}

			// 2. Loop through all incoming answers
			for (const [key, value] of Object.entries(data)) {
				// Prepare Firebase update
				updatePayload[
					`answers.saidAnswers.${sessionData.current_task}.${key}`
				] = value;
				// Optimistically update local state immediately so length check works
				sessionData.answers.saidAnswers[sessionData.current_task][key] = value;
			}

			// 3. Send a single batch update to Firebase
			await updateDoc(sessionRef, updatePayload, { merge: true });

			// 4. Check for victory
			if (
				Object.keys(sessionData.answers.saidAnswers[sessionData.current_task])
					.length >=
				(gameData.taskData.rd_content.requiredAnswers ||
					gameData.taskData.rd_content.answers.length)
			) {
				showMessage({
					msg_content: ui.game.riddle.multiple_all_message,
					msg_type: "info",
					msg_action: ui.game.riddle.multiple_all_action,
				});
				handleComplexSolve();
			} else {
				showMessage({
					msg_content: ui.game.riddle.multiple_more_message,
					msg_type: "info",
					msg_action: ui.game.riddle.multiple_more_action,
				});
			}
		}
	}

	async function handlePartialSolveType2(e) {
		if (checkTooFast()) {
			return true;
		} else {
			let data = e.detail;
			const sessionRef = doc(db, "sessions", sessionData.session.sid);

			let updatePayload = {};

			// 1. Defensively initialize the entire state tree
			if (!sessionData.answers) sessionData.answers = {};
			if (!sessionData.answers.saidAnswers)
				sessionData.answers.saidAnswers = {};
			if (!sessionData.answers.saidAnswers[sessionData.current_task]) {
				sessionData.answers.saidAnswers[sessionData.current_task] = {};
			}

			// Loop through ALL items in the array, looking for EVERY true value
			for (let i = 0; i < data.inActive.length; i++) {
				if (data.inActive[i] === true) {
					let saidAnswer;

					// Find the matching string for this specific index
					if (typeof gameData.taskData.rd_content.answers[i] === "object") {
						saidAnswer = Object.values(
							gameData.taskData.rd_content.answers[i],
						)[0];
					} else {
						saidAnswer = gameData.taskData.rd_content.answers[i];
					}

					updatePayload[
						`answers.saidAnswers.${sessionData.current_task}.${saidAnswer}`
					] = true;
					sessionData.answers.saidAnswers[sessionData.current_task][
						saidAnswer
					] = true;
				}
			}

			await updateDoc(sessionRef, updatePayload, { merge: true });

			if (
				Object.keys(sessionData.answers.saidAnswers[sessionData.current_task])
					.length >=
				(gameData.taskData.rd_content.requiredAnswers ||
					gameData.taskData.rd_content.answers.length)
			) {
				showMessage({
					msg_content: ui.game.riddle.multiple_all_message,
					msg_type: "info",
					msg_action: ui.game.riddle.multiple_all_action,
				});
				handleComplexSolve();
			} else {
				showMessage({
					msg_content: ui.game.riddle.multiple_more_message,
					msg_type: "info",
					msg_action: ui.game.riddle.multiple_more_action,
				});
			}
		}
	}

	async function handleCheckPartialSolve() {
		if (
			Object.keys(sessionData.answers.saidAnswers[sessionData.current_task])
				.length >=
			(gameData.taskData.rd_content.requiredAnswers ||
				gameData.taskData.rd_content.answers.length)
		) {
			// console.log("they're equal");
			showMessage({
				msg_content: ui.game.riddle.multiple_all_message,
				msg_type: "info",
				msg_action: ui.game.riddle.multiple_all_action,
			});
			handleComplexSolve();
		} else {
			// console.log('more to solve');
			showMessage({
				msg_content: ui.game.riddle.multiple_more_message,
				msg_type: "info",
				msg_action: ui.game.riddle.multiple_more_action,
			});
		}
	}

	async function handleSkipBonus(e) {
		if (confirm(ui.game.bonus_riddle_skip_confirmation)) {
			const sessionRef = doc(db, "sessions", sessionData.session.sid);
			if (
				gameData.taskData.rd_content.address !== "zteakujehucihiafaha" &&
				gameData.taskData.rd_content.address !== "conclusion"
			) {
				showMessage({
					msg_content: ui.game.bonus_riddle_skip_message,
					msg_type: "info",
				});
				await updateDoc(
					sessionRef,
					{
						current_task: gameData.taskData.rd_content.address,
						["session.riddleTimes." + sessionData.current_task]:
							serverTimestamp(),
						// ['session.normal_riddles_solved']: increment(1),
					},
					{ merge: true },
				).then(() => {
					loader = true;
					getCurrentTask();
				});
			} else {
				await updateDoc(
					sessionRef,
					{
						["session.riddleTimes." + sessionData.current_task]:
							serverTimestamp(),
						current_task: "conclusion",
						"session.ended": true,
						"session.sessionEnd": serverTimestamp(),
					},
					{ merge: true },
					// ).then(() => addToLeaderboard());
				); // either this or the one above
				// add to access code data

				const accCodeRef = doc(
					db,
					"game-activation-codes",
					sessionData.session.activation_code,
				);
				await updateDoc(
					accCodeRef,
					{
						game_over: true,
					},
					{ merge: true },
				);

				let playersArray = Object.keys(sessionData.session.players);
				playersArray.forEach(async (element) => {
					const userRef = doc(db, "users", element);
					await updateDoc(
						userRef,
						{
							activeSessionID: deleteField(),
							hasActiveSession: false,
							latestSession: sessionData.session.sid,
							showConclusion: true,
							pastSessions: arrayUnion(sessionData.session.sid),
						},
						{ merge: true },
					).then(() => {});
				});

				location.reload();
				//reload when players reached conclusion
			}
		} else {
			// console.log('You pressed Cancel!');
			// hint.open = false;
			// slider.value = 1;
		}
	}

	async function handleSkipSkippable(e) {
		if (confirm(ui.game.skippable_riddle_skip_confirmation)) {
			const sessionRef = doc(db, "sessions", sessionData.session.sid);
			if (
				gameData.taskData.rd_content.address !== "zteakujehucihiafaha" &&
				gameData.taskData.rd_content.address !== "conclusion"
			) {
				showMessage({
					msg_content: ui.game.skippable_riddle_skip_message,
					msg_type: "info",
				});
				await updateDoc(
					sessionRef,
					{
						current_task: gameData.taskData.rd_content.address,
						["session.riddleTimes." + sessionData.current_task]:
							serverTimestamp(),
						// ['session.normal_riddles_solved']: increment(1),
					},
					{ merge: true },
				).then(() => {
					loader = true;
					getCurrentTask();
				});
			} else {
				await updateDoc(
					sessionRef,
					{
						["session.riddleTimes." + sessionData.current_task]:
							serverTimestamp(),
						current_task: "conclusion",
						"session.ended": true,
						"session.sessionEnd": serverTimestamp(),
					},
					{ merge: true },
					// ).then(() => addToLeaderboard());
				); // either this or the one above
				// add to access code data

				const accCodeRef = doc(
					db,
					"game-activation-codes",
					sessionData.session.activation_code,
				);
				await updateDoc(
					accCodeRef,
					{
						game_over: true,
					},
					{ merge: true },
				);

				let playersArray = Object.keys(sessionData.session.players);
				playersArray.forEach(async (element) => {
					const userRef = doc(db, "users", element);
					await updateDoc(
						userRef,
						{
							activeSessionID: deleteField(),
							hasActiveSession: false,
							latestSession: sessionData.session.sid,
							showConclusion: true,
							pastSessions: arrayUnion(sessionData.session.sid),
						},
						{ merge: true },
					).then(() => {});
				});

				location.reload();
				//reload when players reached conclusion
			}
		} else {
			// console.log('You pressed Cancel!');
			// hint.open = false;
			// slider.value = 1;
		}
	}

	function showMessage(message) {
		if (message.hasOwnProperty("msg_type")) {
			msg_type = message.msg_type;
		} else {
			msg_type = "default";
		}

		msg_content = message.msg_content;

		if (message.hasOwnProperty("msg_action")) {
			msg_action = message.msg_action;
		} else {
			msg_action = ui.message.default_okay;
		}

		if (message.hasOwnProperty("msg_color")) {
			msg_color = message.msg_color;
		} else {
			msg_color = false;
		}
		msg_shown = true;
	}

	async function addToLeaderboard() {
		// console.log('add to leaderboard began');
		//duration
		sessionData.startTime = sessionData.session.sessionStart.toDate();
		if (sessionData.session.sessionEnd) {
			sessionData.endTime = sessionData.session.sessionEnd.toDate();
		} else {
			sessionData.endTime = new Date(Date.now());
		}
		// console.log('start-end', sessionData.startTime, sessionData.endTime);
		sessionData.duration_floor = Math.floor(
			(sessionData.endTime.getTime() - sessionData.startTime.getTime()) / 1000,
		);
		// console.log('duration', sessionData.duration_floor);
		// score_from_normal_riddles
		sessionData.score_from_normal_riddles =
			sessionData.session.normal_riddles_solved *
			gamerule.points_for_normal_riddle;
		// score_from_bonus_riddles
		sessionData.score_from_bonus_riddles = sessionData.session
			.bonus_riddles_solved
			? sessionData.session.bonus_riddles_solved *
				gamerule.points_for_bonus_riddle
			: 0;
		// score_bonus_from_time
		if (sessionData.duration_floor <= 7200) {
			sessionData.score_bonus_from_time = Math.round(
				map(sessionData.duration_floor, 900, 7200, 500, 250),
			);
		} else {
			sessionData.score_bonus_from_time = Math.round(
				map(sessionData.duration_floor, 7200, 86400, 250, 100),
			);
		}
		// hints
		if (sessionData.hints) {
			sessionData.usedHintsArray = Object.keys(sessionData.hints.hintsUsed);
			sessionData.usedHintsTime = 0;
			sessionData.usedHintsCount = 0;

			sessionData.usedHintsArray.forEach((element) => {
				let keys = Object.keys(sessionData.hints.hintsUsed[element]);
				let values = Object.values(sessionData.hints.hintsUsed[element]);
				sessionData.usedHintsCount = sessionData.usedHintsCount + keys.length;

				values.forEach((element) => {
					sessionData.usedHintsTime = sessionData.usedHintsTime + element;
				});
			});
		} else {
			sessionData.usedHintsTime = 0;
			sessionData.usedHintsCount = 0;
		}
		sessionData.minus_for_hints = sessionData.usedHintsTime;
		// score_normal_minus_hints
		sessionData.score_normal_minus_hints =
			sessionData.score_from_normal_riddles - sessionData.minus_for_hints;
		// total score
		sessionData.totalScore =
			sessionData.score_from_normal_riddles +
			sessionData.score_from_bonus_riddles +
			sessionData.score_normal_minus_hints +
			sessionData.score_bonus_from_time;
		// console.log('total score:', sessionData.totalScore);
		const leaderboardRef = doc(db, "leaderboard", sessionData.session.sid);
		await setDoc(leaderboardRef, {
			team_name: sessionData.session.team_name,
			session_id: sessionData.session.sid,
			session_start: sessionData.session.sessionStart,
			session_end: serverTimestamp(),
			gid: sessionData.game.gid,
			score: sessionData.totalScore,
		}).then(); //() => console.log('Total score: ', sessionData.totalScore)
	}

	function handleSetLang(event) {
		dispatch("setLang", event.detail);
	}

	function handleSurrender(e) {
		surrender = e.detail;
		if (surrender) {
			mapOpen = false;
			chatOpen = false;
		}
	}

	async function surrenderSession() {
		// exodus
		const sessionRef = doc(db, "sessions", sessionData.session.sid);

		await updateDoc(
			sessionRef,
			{
				current_task: "conclusion",
				"session.ended": true,
				"session.exodus": true,
				"session.sessionEnd": serverTimestamp(),
			},
			{ merge: true },
		);
		// .then(() => addToLeaderboard());

		// add to access code data

		const accCodeRef = doc(
			db,
			"game-activation-codes",
			sessionData.session.activation_code,
		);
		await updateDoc(
			//this should happen to all users that are in the session
			accCodeRef,
			{
				game_over: true,
			},
			{ merge: true },
		);

		// console.log(sessionData.session.players);
		let playersArray = Object.keys(sessionData.session.players);
		playersArray.forEach(async (element) => {
			const userRef = doc(db, "users", element);
			await updateDoc(
				//this should happen to all users that are in the session
				userRef,
				{
					activeSessionID: deleteField(),
					hasActiveSession: false,
					latestSession: sessionData.session.sid,
					showConclusion: true,
					pastSessions: arrayUnion(sessionData.session.sid),
				},
				{ merge: true },
			).then(() => {
				// console.log(element);
			});
		});
		logEvent(analytics, "session_ingame_surrender");
		let state = "conclusion";
		dispatch("state", state);
		location.reload();
		//reload when players reached conclusion
	}

	// let customScriptingLoaded = false;

	function loadJS(FILE_URL, async = true) {
		// if (document.getElementById('customScripting')) {
		//     console.log('script already created');
		//     document.getElementById('customScripting').remove();
		// }
		// if (!customScriptingLoaded) {
		let scriptEle = document.createElement("script");

		scriptEle.setAttribute("src", FILE_URL);
		scriptEle.setAttribute("id", "customScripting");
		scriptEle.setAttribute("type", "text/javascript");
		scriptEle.setAttribute("async", async);

		document.body.appendChild(scriptEle);

		// success event
		scriptEle.addEventListener("load", () => {
			// console.log('File loaded');
			// customScriptingLoaded = true;
		});
		// error event
		scriptEle.addEventListener("error", (ev) => {
			console.log("Error on loading file", ev);
		});
		// } else {
		//     console.error('ELSA sNOw power');
		// }
	}

	function checkCustomScripting() {
		if (gameData.taskData.customScripting) {
			// const queryString = ;
			// console.log(queryString);
			const urlParams = new URLSearchParams(window.location.search);
			let cs = gameData.taskData.csId || "t";
			// console.log(urlParams);
			// console.log(urlParams.get('cs'));
			// console.log(cs);
			if (cs == urlParams.get("cs")) {
				loadJS(gameData.taskData.customScripting, false);
			} else {
				// window.location.href = window.location.href + '?cs=' + cs;
				let url = new URL(window.location.href);
				url.searchParams.set("cs", cs);
				window.location.href = url;
			}
			// console.log(gameData.taskData.customScripting);
		} else {
			let url = new URL(window.location.href);
			url.searchParams.delete("cs");
			history.replaceState(undefined, undefined, url);
		}
	}

	function handleMap(e) {
		mapOpen = e.detail;
		if (mapOpen) {
			surrender = false;
			chatOpen = false;
		}
		// console.log(e.detail);
	}

	async function handleChat(e) {
		chatOpen = e.detail;
		if (chatOpen) {
			surrender = false;
			mapOpen = false;
		}
		if (chatOpen && sessionData?.unreadAdminMessages > 0) {
			const sessionRef = doc(db, "sessions", sessionData.session.sid);
			await updateDoc(sessionRef, {
				unreadAdminMessages: 0,
			});
		}
		// console.log(e.detail);
	}

	// When the user toggles the chat from the header
	// async function handleChatToggle(event) {
	//     chatOpen = event.detail; // true or false

	//     // If they just opened the chat, and there are unread messages, reset the counter
	//     if (chatOpen && sessionData?.unreadAdminMessages > 0) {
	//         const sessionRef = doc(db, "sessions", sessionData.session.sid);
	//         await updateDoc(sessionRef, {
	//             unreadAdminMessages: 0
	//         });
	//     }
	// }
	//TODO:
	//Add message boards when answers are right

	function handleGeoIntent(e) {
		autoGeolocate = e.detail;
	}
</script>

<Messageboard
	{msg_type}
	{msg_content}
	{msg_shown}
	{msg_action}
	{msg_color}
	on:msg={(e) => {
		msg_shown = e.detail;
		// console.log(e.detail);
	}}
/>

<TutorialOverlay
	{tutorial_state}
	{lang}
	on:ttrl={(e) => {
		tutorial_state = e.detail;
		// console.log(e.detail);
	}}
/>

{#if loader == false}
	{#if gameData.taskData && surrender == false && mapOpen == false && chatOpen == false}
		{#if gameData.taskData.customStyling}
			{@html gameData.taskData.customStyling}
		{/if}

		{#if gameData.taskData.header !== undefined ? gameData.taskData.header == "default" || gameData.taskData.header.default == true : false}
			<GameHeader
				{lang}
				{hasMap}
				{hasChat}
				{mapOpen}
				{surrender}
				{chatOpen}
				unreadCount={sessionData?.unreadAdminMessages || 0}
				on:map={handleMap}
				on:chat={handleChat}
				on:surrender={handleSurrender}
				on:setLang={handleSetLang}
			/>
		{:else}
			<header>{@html gameData.taskData.header}</header>
		{/if}
		{#if gameData.taskData.rd_content.isBonus}
			<BonusHeader {lang} on:skipBonus={handleSkipBonus} />
		{/if}
		{#if gameData.taskData.rd_content.isSkippable}
			<SkippableHeader {lang} on:skipSkippable={handleSkipSkippable} />
		{/if}
		{#if gameData.taskData.showTimer || sessionData.showTimer}
			<SessionTimer {lang} {sessionData} taskData={gameData.taskData} />
		{/if}

		<main
			class="mx-auto 2xl:max-w-4xl lg:max-w-3xl obelisk role-{sessionData
				?.session.players[user.uid].role} variant-{sessionData?.teamVariant
				? sessionData?.teamVariant
				: 'default'}"
		>
			<section
				id="riddle"
				class="grid max-w-5xl pb-8 mx-auto place-content-center"
			>
				{@html gameData.taskData.main}
			</section>

			<!-- 📌 Geolocked Riddle part -->
			{#if gameData.taskData.geo_content}
				<GeoRiddle
					{lang}
					taskData={gameData.taskData}
					{sessionData}
					on:message={handleMessage}
				></GeoRiddle>
			{/if}

			<!-- 📌 Geolocked Riddle part -->

			<section id="input" class="grid">
				{#if microinput}
					{#if !(msg_shown && msg_type == "info")}
						{#if gameData.taskData.aside == "default" || gameData.taskData.aside.default == true}
							{#if gameData.taskData.rd_content.type == "single" || gameData.taskData.rd_content.type == "multiple"}
								<InputSimple
									{lang}
									riddle={gameData.taskData.rd_content}
									on:input={handleInput}
									on:message={handleMessage}
									on:solve={handleSolve}
									on:wrongAnswer={handleWrongAnswer}
								/>
							{:else if gameData.taskData.rd_content.type == "dnd-reorder" || gameData.taskData.rd_content.type == "dnd-reorder-show-input"}
								<InputReorder
									{lang}
									riddle={gameData.taskData.rd_content}
									on:input={handleInput}
									on:message={handleMessage}
									on:solve={handleSolve}
									on:wrongAnswer={handleWrongAnswer}
								/>
								<!-- 
                        pastAnswers={sessionData.answers
                        ? sessionData.answers.saidAnswers[sessionData.current_task]
                        : false}
                        on:complexSolve={handleComplexSolve}
                        on:partialSolve={handlePartialSolve}
                on:partialSolveType2={handlePartialSolveType2} -->
							{:else if gameData.taskData.rd_content.type == "btn-order" || gameData.taskData.rd_content.type == "btn-order-hidden" || gameData.taskData.rd_content.type == "btn-to-input"}
								<InputButtoned
									{lang}
									riddle={gameData.taskData.rd_content}
									on:input={handleInput}
									on:message={handleMessage}
									on:solve={handleSolve}
									on:wrongAnswer={handleWrongAnswer}
								/>
							{:else if gameData.taskData.rd_content.type == "qr" || gameData.taskData.rd_content.type == "qr-mc" || gameData.taskData.rd_content.type == "qr-multiple" || gameData.taskData.rd_content.type == "qr-mc-multiple"}
								<InputQr
									{lang}
									riddle={gameData.taskData.rd_content}
									pastAnswers={sessionData.answers
										? sessionData.answers.saidAnswers[sessionData.current_task]
										: false}
									on:input={handleInput}
									on:message={handleMessage}
									on:solve={handleSolve}
									on:complexSolve={handleComplexSolve}
									on:partialSolve={handlePartialSolve}
									on:partialSolveType2={handlePartialSolveType2}
									on:checkPartialSolve={handleCheckPartialSolve}
									on:wrongAnswer={handleWrongAnswer}
								/>
							{:else}
								<!-- <h3>COMPLEX INPUT here</h3> -->
								<!-- {#if sessionData.answers} -->
								<InputComplex
									{lang}
									riddle={gameData.taskData.rd_content}
									pastAnswers={sessionData.answers
										? sessionData.answers.saidAnswers[sessionData.current_task]
										: false}
									on:input={handleInput}
									on:message={handleMessage}
									on:complexSolve={handleComplexSolve}
									on:partialSolve={handlePartialSolve}
									on:partialSolveType2={handlePartialSolveType2}
									on:checkPartialSolve={handleCheckPartialSolve}
									on:solve={handleSolve}
									on:wrongAnswer={handleWrongAnswer}
								/>
								<!-- {:else}
                            <InputComplex
                                {lang}
                                riddle={gameData.taskData.rd_content}
                                pastAnswers={false}
                                on:input={handleInput}
                                on:message={handleMessage}
                                on:complexSolve={handleComplexSolve}
                                on:partialSolve={handlePartialSolve}
                                on:partialSolveType2={handlePartialSolveType2}
                                on:solve={handleSolve}
                            />
                        {/if} -->
							{/if}
						{:else}
							<aside>{@html gameData.taskData.aside}</aside>
						{/if}
					{/if}
				{/if}
			</section>

			{#if gameData.taskData.rd_content.hints}
				<section id="hints">
					<!-- game has hints -->
					{#if sessionData.hints}
						<Hints
							{lang}
							hints={gameData.taskData.rd_content.hints}
							usedHints={sessionData.hints.hintsUsed[sessionData.current_task]}
							on:usingHint={handleUsingHint}
						/>
					{:else}
						<Hints
							{lang}
							hints={gameData.taskData.rd_content.hints}
							usedHints={false}
							on:usingHint={handleUsingHint}
						/>
					{/if}
				</section>
			{/if}
		</main>

		{#if gameData.taskData.footer !== "default"}
			{@html gameData.taskData.footer}
		{/if}
		<GameFooter {lang} joinCode={sessionData.access_code} />
	{:else if hasMap == true && mapOpen == true}
		<GameHeader
			{lang}
			{hasMap}
			{hasChat}
			{mapOpen}
			{surrender}
			{chatOpen}
			unreadCount={sessionData?.unreadAdminMessages || 0}
			on:map={handleMap}
			on:chat={handleChat}
			on:surrender={handleSurrender}
			on:setLang={handleSetLang}
		/>

		<!-- <Map3 {lang} {mapData} /> -->
		<Mapbox
			{lang}
			{mapData}
			customStyling={gameData.taskData.customStyling}
			{autoGeolocate}
			on:geoIntent={handleGeoIntent}
		/>
	{:else if hasChat == true && chatOpen == true}
		{#if gameData.taskData.customStyling}
			{@html gameData.taskData.customStyling}
		{/if}
		<GameHeader
			{lang}
			{hasMap}
			{hasChat}
			{mapOpen}
			{surrender}
			{chatOpen}
			unreadCount={sessionData?.unreadAdminMessages || 0}
			on:map={handleMap}
			on:chat={handleChat}
			on:surrender={handleSurrender}
			on:setLang={handleSetLang}
		/>
		<PlayerChat {lang} {storage} {sessionData} {db} {user}></PlayerChat>
		<!-- <Map3 {lang} {mapData} /> -->
		<!-- <Mapbox {lang} {mapData} customStyling={gameData.taskData.customStyling} /> -->
	{:else if surrender == true}
		{#if gameData.taskData.customStyling}
			{@html gameData.taskData.customStyling}
		{/if}
		<GameHeader
			{lang}
			{hasMap}
			{hasChat}
			{mapOpen}
			{surrender}
			{chatOpen}
			unreadCount={sessionData?.unreadAdminMessages || 0}
			on:map={handleMap}
			on:surrender={handleSurrender}
			on:setLang={handleSetLang}
		/>
		<main
			class="grid text-center obelisk place-content-center place-items-center"
		>
			<h1>{ui.new_join.surrender_title}</h1>

			{#if Object.keys(sessionData.session.players).length > 1}
				<p class="my-5">
					{ui.new_join.surrender_multiple_leave_description}
				</p>
				<button
					class="justify-center place-self-center outline"
					on:click={() => leaveSession()}
				>
					<i class="fa-solid fa-right-from-bracket" data-position="left" />{ui
						.new_join.leave_session}
				</button>

				<p class="my-5">
					{ui.new_join.surrender_multiple_surrender_description}
				</p>
			{:else}
				<p class="mt-5">
					{ui.new_join.surrender_single_gameover_description}
				</p>
				<p class="mb-5">
					{ui.new_join.surrender_single_surrender_description}
				</p>
			{/if}

			<input
				class="mt-5 text-center"
				type="text"
				name="field"
				id="field"
				maxlength="256"
				placeholder={sessionData.session.team_name}
				bind:value={surrender_input}
			/>
			<div class="flex flex-wrap-reverse justify-center place-content-center">
				<button on:click={() => (surrender = false)}>
					<i class="fa-solid fa-circle-left" data-position="left" />{ui.new_join
						.back}
				</button>
				<button
					on:click={() => surrenderSession()}
					disabled={surrender_input !== sessionData.session.team_name}
				>
					<i class="fa-solid fa-circle-xmark" data-position="left" />{ui
						.new_join.surrender}
				</button>
			</div>
		</main>
		<GameFooter {lang} {v} joinCode={sessionData.access_code} />
	{/if}
{/if}
